import { appPageTransition } from "../common";

(() => {
  if ("undefined" === typeof CURRENT_APP || CURRENT_APP !== "drive") {
    return;
  }

  const DRINK_REMOVE_BUTTON =
    '<button class="btn btn-outline-danger drive-drink-remove" data-drink="drive-drink-id1" type="button">X</button>';
  const DRINK_FORM = `${$("#drive-drink-container")
    .html()
    .trim()
    .slice(0, -6)}${DRINK_REMOVE_BUTTON}</div>`;
  let nextDrinkId = 1;

  const round = (n, dec) => {
    let num = n * Math.pow(10, dec);
    num = Math.round(num);
    return (num / Math.pow(10, dec)).toFixed(dec);
  };

  const getAlcool = () => {
    let total = 0;

    $(".drive-drink").each(function () {
      let num = $(this).children(".drive-drink-number").val();
      let drink = $(this).children(".drive-drink-name").val();

      total += Number(num) * DRIVE_DRINKS[drink] * 10;
    });

    return total;
  };

  $("#drive-continue").on("click", () =>
    appPageTransition("drive-about-me", "drive-drink")
  );
  $("#drive-previous").on("click", () =>
    appPageTransition("drive-drink", "drive-about-me", {
      out: "right",
      in: "left",
    })
  );

  $("#drive-sex").on("change", function () {
    let isMale = $(this).val() === "m";
    $("#drive-weight")
      .attr("min", isMale ? 50 : 40)
      .attr("max", isMale ? 150 : 140);
  });

  const calculateAlcool = () => {
    // Widmark's formula

    // Widmark's  r
    let r =
      $("#drive-sex").val() === "m"
        ? 0.68 // Men: 0.50 to 0.90, average 0.68
        : 0.55; // Women: 0.45 to 0.63, average 0.55

    let beta = 0.017; // Widmark 0.010%/hr to 0.024%/hr, average 0.017%/hr.

    let n = 5.14; // Each fluid ounce of EtOH weighs 0.0514 pounds.
    let g = 1.055; // gravity of blood (1.055 g/ml)

    let weight = Number($("#drive-weight").val());
    let time =
      Number($("#drive-time").val()) / Number($("#drive-measure").val());
    let glBac = 1.055;

    let bac =
      ((getAlcool() * 0.035195 * n * g) / ((weight / 0.453592) * r) -
        time * beta) *
      10 *
      glBac;
    bac = bac < 0 ? 0 : bac;

    $("#drive-result-container").removeClass("d-none");
    $("#drive-result").val(round(bac, 4));

    $(".drive-table-row").removeClass("table-danger");

    if (bac >= 1.2) {
      $("#drive-table-row-3").addClass("table-danger");
    } else if (bac >= 0.8) {
      $("#drive-table-row-2").addClass("table-danger");
    } else if (bac >= 0.5) {
      $("#drive-table-row-1").addClass("table-danger");
    }
  };

  $(".drink-input").on("change", calculateAlcool);

  const removeDrink = function () {
    $(`#${$(this).attr("data-drink")}`).remove();
    let removeButtons = $(".drive-drink-remove");

    if (removeButtons.length === 1) {
      removeButtons.remove();
    }

    calculateAlcool();
  };

  $("#drive-drink-add").on("click", () => {
    let drinks = $(".drive-drink");

    if (drinks.length === 1) {
      let drinkId = drinks.attr("id");
      drinks.append(DRINK_REMOVE_BUTTON.replaceAll("drive-drink-id1", drinkId));
    }

    nextDrinkId += 1;
    $("#drive-drink-container").append(
      DRINK_FORM.replaceAll("-id1", `-id${nextDrinkId}`)
    );
    $(".drive-drink-remove").on("click", removeDrink);
    $("#drive-drink-container .drink-input").on("change", calculateAlcool);

    calculateAlcool();
  });
})();
